import type { ContentItemType } from '../generated/social-media/metapicSocialMediaAPIDocumentation.schemas'
import {
  type ContentTypeOption,
  PLATFORM_CONTENT_TYPES,
  SUPPORTED_CONTENT_ITEM_PLATFORMS,
  type SupportedContentItemPlatform,
} from '../types/content-item-platform.types'

const PLATFORM_LABELS: Record<SupportedContentItemPlatform, string> = {
  instagram: 'Instagram',
  snapchat: 'Snapchat',
  tiktok: 'TikTok',
}

/**
 * Domain data: what each content type is called in the UI. Exhaustive by construction — a type added to
 * the generated union stops this compiling until it is labelled.
 */
export const CONTENT_TYPE_LABELS: Record<ContentItemType, string> = {
  instagram_story: 'Stories',
  instagram_post: 'Posts',
  instagram_reel: 'Reels',
  snapchat_story: 'Stories',
  snapchat_snap: 'Snaps',
  tiktok_post: 'Posts',
}

/** UI policy, not domain data: adding a platform here is the only edit needed to give it a submenu. */
const NARROWABLE_PLATFORMS = [
  'instagram',
] as const satisfies readonly SupportedContentItemPlatform[]

// `.map` builds a fresh array of fresh objects on each platform, so callers cannot corrupt the
// readonly tuples in PLATFORM_CONTENT_TYPES through this table.
export const platformContentTypeOptions: ContentTypeOption[] = SUPPORTED_CONTENT_ITEM_PLATFORMS.map(
  (platform) => ({
    label: PLATFORM_LABELS[platform],
    value: platform,
    contentTypes: (PLATFORM_CONTENT_TYPES[platform] as readonly ContentItemType[]).map((type) => ({
      label: CONTENT_TYPE_LABELS[type],
      value: type,
    })),
    narrowable: (NARROWABLE_PLATFORMS as readonly string[]).includes(platform),
  }),
)
